import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-contents-navigation-footer',
	templateUrl:'./WaPageContentsNavigationFooterProPage.html',
	styles: [],
	styleUrls:['./WaPageContentsNavigationFooterProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageContentsNavigationFooterProPage
{
	mdContent_392 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageContentsNavigationFooter;
\`\`\``;
	mdContent_393 = `\`\`\`java
new WaPageContentsNavigationFooter<>()
\`\`\``;
}
